import { render } from "./PremiumList.vue?vue&type=template&id=759987a0&scoped=true"
import script from "./PremiumList.vue?vue&type=script&lang=js"
export * from "./PremiumList.vue?vue&type=script&lang=js"

import "./PremiumList.vue?vue&type=style&index=0&id=759987a0&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759987a0"]])

export default __exports__